import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useMessage } from '../contexts/MessageContext';
import { Loading } from './common/Loading';

const apiUrl = window._env_?.REACT_APP_API_URL || "https://app.mylocaleventrentals.com/api";

const CustomerEdit = () => {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const { logout, getToken } = useAuth();
  const { showSuccess, showError } = useMessage();
  const [form, setForm] = useState({ firstname: '', lastname: '', email: '', phone: '', line1:'', city:'', state:'',zipcode:'' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [addressUuid, setAddressUuid ] = useState(null);
  
  useEffect(() => {
  const fetchCustomer = async () => {
    const token = getToken ? getToken() : localStorage.getItem('token');
    if (!token) {
      logout();
      showError('Authentication required. Please log in.');
      return;
    }

    try {
      setLoading(true);

      const [customerRes, addressRes] = await Promise.all([
        axios.get(`${apiUrl}/customers/${uuid}`, {
          headers: { 'x-auth-token': token }
        }),
        axios.get(`${apiUrl}/customer-address`, {
          params: {
            customer_id: uuid,
            is_primary: true
          },
          headers: { 'x-auth-token': token }
        })
      ]);

      /** ---------- CUSTOMER ---------- */
      const customer = customerRes.data?.data;
      if (!customer) {
        showError('Customer not found');
        navigate('/CustomerList');
        return;
      }

      /** ---------- ADDRESS ---------- */
      console.log(addressRes);
      const address = addressRes.data?.data?.[0]?.Address; // 🔥 array fix
      console.log(address);
      if(address){
        setAddressUuid(address.uuid);
      }
      setForm(prev => ({
        ...prev,
        firstname: customer.firstname || '',
        lastname: customer.lastname || '',
        email: customer.email || '',
        phone: customer.phone || '',
        line1: address?.line1 || '',
        city: address?.city || '',
        state: address?.state || '',
        zipcode: address?.postal_code || ''
      }));

    } catch (err) {
      console.error(err);
      showError('Failed to load customer');
      navigate('/CustomerList');
    } finally {
      setLoading(false);
    }
  };

  fetchCustomer();
  // eslint-disable-next-line
}, [uuid]);


  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    const token = getToken ? getToken() : localStorage.getItem('token');
    if (!token) {
      logout();
      showError('Authentication required. Please log in.');
      setSaving(false);
      return;
    }
    try {
      const res = await axios.put(
        `${apiUrl}/customers/${uuid}`,
        form,
        { headers: { 'x-auth-token': token } }
      );

      const addressPayload = {
        line1: form.line1,
        city: form.city,
        state: form.state,
        postal_code: form.zipcode
      };
      //if addressUuid available update else create address and link to customer
      console.log('---addressUuid---'+addressUuid);
      if(addressUuid){
          await axios.put(`${apiUrl}/address/${addressUuid}`, addressPayload, {
            headers: { 'x-auth-token': token }
          });
      }else{
        console.log('---addressUuid not found---');
        const addressCreate = await axios.post(`${apiUrl}/address`, addressPayload,{
            headers: { 'x-auth-token': token }
          }
        );
        console.log(addressCreate.data.data.uuid);
        console.log('---customer id---'+uuid);
        await axios.post(`${apiUrl}/customer-address`, 
          {customer_id: uuid,address_id: addressCreate.data.data.uuid, "is_primary": true },
          { headers: { 'x-auth-token': token }}

        );
      }


      if (res.data.success) {
        showSuccess('Customer updated successfully!');
        setTimeout(() => navigate(`/CustomerList`), 1200);
      } else {
        showError(res.data.message || 'Failed to update customer');
      }
    } catch (err) {
      showError('Failed to update customer');
    }
    setSaving(false);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-8 max-w-lg mx-auto bg-white m-5 p-6 rounded shadow-md">
      <h2 className="text-xl font-bold text-gray-800 mb-4">Edit Customer</h2>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">First Name</label>
        <input
          type="text"
          name="firstname"
          value={form.firstname}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Last Name</label>
        <input
          type="text"
          name="lastname"
          value={form.lastname}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <input
          type="email"
          name="email"
          value={form.email}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
        <input
          type="text"
          name="phone"
          value={form.phone}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>
       {/* Address data */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Address</label>
        <input
          type="text"
          name="line1"
          value={form.line1}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">City</label>
        <input
          type="text"
          name="city"
          value={form.city}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">State</label>
        <input
          type="text"
          name="state"
          value={form.state}
          onChange={handleChange}
          className="w-full p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="flex gap-3 pt-4 border-t border-gray-200">
        <button
          type="submit"
          disabled={saving}
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
        <button
          type="button"
          onClick={() => navigate(`/CustomerList`)}
          className="px-6 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default CustomerEdit;
